
/**
 * @fileOverview ContentRelocationController Module, moves content from one context to another when a specified event
 * is triggered.
 *
 * @author jmaki
 * @version 1.0
 */

(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ContentRelocationController',['require','exports','module','lib/Util','jquery','GlobalEventDispatcher'],function (require, module, exports) {
        var Util = require('lib/Util');
        var $ = require('jquery');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');

        /**
         * Description
         *
         * @name ContentRelocationController
         * @class ContentRelocationController This is used to set up an event in which an element will be moved
         * within the DOM
         * @constructor
         *
         * @param element {Element} the target element to move
         * @param options {Object} the options used to initialize the object
         * @param app {App} the application instance
         *
         * @since 1.0
         */
        var ContentRelocationController = function (element, options) {
            this.$element = $(element); //the element that gets moved
            this.$target = $(options.target); //the target div
            this.event = options.event; // name of the event that triggers the relocation
            this.append = options.append || false;  //toggles if the content is appended / prepended to the target div
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by layout and enable
         *
         * @returns {ContentRelocationController}
         * @since 1.0
         */
        ContentRelocationController.prototype.init = function () {
            this.isEnabled = false;
            return this.setupHandlers()
                .enable();
        };


        /**
         *  Subscribe to the event that will trigger the relocation
         *
         * @returns {ContentRelocationController}
         * @since 1.0
         */
        ContentRelocationController.prototype.setupHandlers = function () {
            var self = this;
            /*ToDO - Refactor so that we can leverage the GlobalEventDispatcher.EVENT object */
            this.eventDispatcher.subscribe(this.event, this.layout.bind(this));
            return this;
        };


        /**
         * Moves the content to the target DOM node, appending or pre-pending based on boolean set on init.  The jsReady
         * class is added in order to allow the css that makes the content visible to be applied only after it is in the
         * correct location, this stops the content from flashing on the screen when you bring up the menu in the mobile
         * view.
         *
         * @returns {ContentRelocationController}
         * @since 1.0
         */
        ContentRelocationController.prototype.layout = function () {
            if (this.isEnabled === false) {
                return this;
            }
            var self = this;
            if (this.append === true) {
                self.$target.append(self.$element);
                self.$element.addClass('jsReady');
            } else {
                self.$target.prepend(self.$element);
                self.$element.addClass('jsReady');
            }
            return this;
        };

        /**
         * Enables the view
         * Exits early if it is already enabled
         *
         * @returns {ContentRelocationController}
         * @since 1.0
         */
        ContentRelocationController.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }
            else {
                //$debug('ContentRelocationController.js loaded/enabled');
                this.isEnabled = true;
            }
            return this;
        };

        /**
         * Disables the view
         * Exits early if it is already disabled
         *
         * @returns {ContentRelocationController}
         * @since 1.0
         */
        ContentRelocationController.prototype.disable = function () {
            if (this.isEnabled === true) {
                return this;
            }
            this.isEnabled = false;

            return this;
        };


        return ContentRelocationController;
    });

}(MMMRequire));

